<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div class="row pl-4 pr-4" v-show="tela == 1">
            <h4 slot="header" class="card-title text-left m-0">
              RELATÓRIO ANALÍTICO DE COORDENADAS GPS
            </h4>
            <BaseFiltroRelatorio
              class="col-sm-6 col-12"
              @pesquisar="pesquisar"
              :btEnviarEmail="false"
            />
            <div class="offset-sm-6 "></div>
          </div>

          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>

            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      {{ `RELATÓRIO ANALÍTICO DE COORDENADAS GPS` }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                                            ${moment(
                                              payloadPesquisa.data_final,
                                            ).format("DD/MM/YYYY")}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--Tabela de Resultados-->

            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="min-width: 250px;">Nome</th>
                    <th scope="col">Dia Semana</th>
                    <th scope="col">Batida</th>
                    <th scope="col">Latitude</th>
                    <th scope="col">Longitude</th>
                    <th scope="col">Local</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in tableData" :key="item.key">
                    <td>{{ item.nome }}</td>
                    <td>{{ item.diaSemana }}</td>
                    <td>{{ item.hora }}</td>
                    <td>{{ item.latitude }}</td>
                    <td>{{ item.longitude }}</td>
                    <td>{{ item.local }}</td>
                    <td>
                      <!-- Legenda:
                      0: fora do raio
                      1: dentro do raio
                      2: Sem coordenadas do posto -->
                      <p v-if="item.dentroDoRaio == 0" style="color: red">
                        Inválido
                      </p>
                      <p v-if="item.dentroDoRaio == 1" style="color: #35a887">
                        Válido
                      </p>
                      <p v-if="item.dentroDoRaio == 2" style="color: orange">
                        Sem dados
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseInput, BaseFiltroRelatorio } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroRelatorio,
  },
  computed: {},
  data() {
    return {
      payloadPesquisa: Object,
      tela: 1,
      printing: false,
      isLoading: false,
      dados: Array,
      tableData: [],
    };
  },
  mounted() {},
  methods: {
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    carregarRelatorio(payload, enviarEmail = false) {
      let th = this;
      th.isLoading = true;
      this.axios
        .post(`/api/relatorio/relatorioCoordenadasGps`, payload, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status) {
            this.tableData = response.data.data.dados;
            this.tela = 2;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar relatório!",
            "error",
          );
        });
    },
    enviarEmail(event) {
      this.carregarRelatorio(event, true);
    },
    pesquisar(event) {
      this.isLoading = true;
      this.payloadPesquisa = event;
      this.carregarRelatorio(event);
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
  },
  watch: {},
};
</script>
<style></style>
